import ReactDOM from 'react-dom';
import useHasMounted from 'hooks/useHasMounted';
function Portal(_ref) {
  var targetElement = _ref.targetElement,
    children = _ref.children;
  var hasMounted = useHasMounted();
  if (!hasMounted) return null;
  if (targetElement === null) return children;
  var container = targetElement || document.getElementById('modals-and-popovers') || document.body;
  return /*#__PURE__*/ReactDOM.createPortal(children, container);
}
export default Portal;